'use strict';

const getCountryFromLocaleCookie = require('./modules/util/getCountryFromLocaleCookie');
const formHelper = require('./rituals-form-helper');
const recaptchaConfig = require('./recaptchaConfig');
const Resources = window.Resources || {};
const google = require('./modules/google');
let isvalidG = true;
const currentCountryCode = getCountryFromLocaleCookie();

const regex = {
    phone: {
        default: /^[+]?[ 0-9]{0,20}$/,
        ru: /^[+]?(?:[\s]*?[0-9]){0,12}[\s]*$/
    },
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    email: /^((")("[^"]+?"@)|(([0-9a-zA-Z_]((\.(?!\.))|[-!#\$%&'\*\+\/=\?\^`\{\}\|~\w])*)(?:[0-9a-zA-Z_-])@))((\[)(\[(\d{1,3}\.){3}\d{1,3}\])|(([0-9a-zA-Z][-0-9a-zA-Z]*[0-9a-zA-Z]*\.)+[a-zA-Z0-9]{2,17}))$/,
    password: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
    name: /^(?=.*\D)(?!.*[$€£¥]).{2,50}$/,
    minimumTwoCharacters: /^.{2,}$/,
    date : {
        us    : /^(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]\d{4}$/,
        other : /^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]\d{4}$/,
        birthdayUS: /^(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])$/
    },
    ssn: /^(19|20)?(\d{6}([-+]|\s)\d{4}|(?!19|20)\d{10})$/,
    nif: /^[0-9]{9}$/,
    emojis: /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/,
    cocNumber: currentCountryCode === 'DE' ? /^[a-zA-Z]{3}[0-9]{6}[a-zA-Z]?$/ : (currentCountryCode === 'AT' ? /^[0-9]{6}[a-zA-Z]{1}$/ : /^[0-9]{1,10}$/),
    vat: currentCountryCode == 'PT' ? /^[0-9]{9}$/ : /^.{1,15}$/,
    script: /<(script|img|link|object|embed|iframe)/gi,
    sql: /\b(OR|ALTER|CREATE|DELETE|DROP|EXEC(UTE)?|INSERT(INTO)?|MERGE|SELECT|UPDATE|UNION(ALL)?|--|-- |#|"|==)\b/i
};

const isFieldSafe = (value) => regex.script.test(value) || regex.sql.test(value) ? false : true;


const includesSpecialCharacters = (str) => {
    const charsToCheck = [
        '!',
        '@',
        '#',
        '$',
        '%',
        '^',
        '&',
        '*',
        '(',
        ')',
        '_',
        '+',
        '=',
        '{',
        '}',
        '\\',
        '|',
        '"',
        '"',
        ';',
        ':',
        '<',
        '>',
        ',',
        '/',
        '?',
        '`',
        '~'
    ];
    return charsToCheck.some((char) => str.includes(char));
};

// global form validator settings
const settings = {
    errorClass: 'error js-validator-error error-text',
    errorElement: 'span',
    onkeyup: function (element) {
        if ($(element).data('onkeyup-validate') && !this.checkable(element)) {
            this.element(element);
        }
    },
    onfocusout: function (element) {
        if ($(element).data('prevent-automatic-validation')) {
            return;
        }

        if (!this.checkable(element)) {
            this.element(element);
        }
    },
    errorPlacement: function (error, element) {
        if (element.hasClass('js-warn-addded')) {
            element.siblings('.js-warn-message').addClass('hide');
        }
        if (element.hasClass('js-options-dropdown-custom')){
            error.insertBefore(element.closest('.selectric-wrapper'));
            return;
        }
        if (element.hasClass('js-custom-select')){
            error.insertBefore(element.closest('.selectric-hide-select'));
            return;
        }

        error.insertBefore(element);
    },
    invalidHandler: function(form, validator) {
        const errors = validator.numberOfInvalids();

        if (errors) {
            const errorElement = $(validator.errorList[0].element);

            formHelper.scrollToInputField(errorElement);
        }
    },
    success: function(error, element) {
        element = element.jquery ? element : $(element);

        if (element.hasClass('js-warn-addded')) {
            element.siblings('.js-warn-message').removeClass('hide');
        }
        error.remove();
        $('.js-product-details-content .js-elixir-name-inner').removeClass('js-elixir-error-state');
    }
};
/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
const validatePhone = function(value, el) {
    let isCustomRegexValid = true;
    const trimmedValue = $.trim(value);
    const customRegex = $(el).attr('regex');
    if (typeof customRegex !== 'undefined') {
        isCustomRegexValid = (new RegExp(customRegex)).test(trimmedValue);
    }

    const isOptional = this.optional(el);

    const regexForCountry = currentCountryCode && regex.phone[currentCountryCode.toLowerCase()] || regex.phone['default'];

    const isValid = regexForCountry.test($.trim(value));
    return (isOptional && value.trim() === '') || (isValid && isCustomRegexValid);
};

/**
* @function
* @description Validates that a credit card owner is not a Credit card number
* @param {String} value The owner field which will be validated
* @param {String} el The input field
*/
const validateOwner = function (value) {
    const isValid = regex.notCC.test($.trim(value));
    return isValid;
};

/**
* @function
* @description Validates that a credit card owner is not a Credit card number
* @param {String} value The owner field which will be validated
* @param {String} el The input field
*/
const emptySelect = function (value) {
    return !!value && $.trim(value) !== '';
};

/**
* @function
* @description Validates a given email address against the email regex
* @param {String} value The email address which will be validated
* @param {String} el The input field
*/
const validateEmail = function (value, el) {
    const isOptional = this.optional(el);
    const isValid = regex.email.test($.trim(value));
    return isOptional || isValid;
};
/**
* @function
* @description Validates a given First Name against the emoji regex
* @param {String} value The First Name which will be validated
* @param {String} el The input field
*/
const validateName = function (value, el) {
    return (
        !regex.emojis.test(value.trim()) &&
        isFieldSafe(value) &&
        !includesSpecialCharacters(value) &&
        regex.name.test(value.trim())
    );
};

const validateNameErrorMessage = function (value, el) {
    const trimmedValue = el.value.trim();
    return !regex.minimumTwoCharacters.test(trimmedValue)
        ? Resources.VALIDATE_CUSTOMER_NAME
        : !validateName(trimmedValue, el)
            ? Resources.GLOBAL_INVALID_INPUT
            : '';
};

/**
* @function
* @description Validates a password confirmation field
* @param {String} value The password confirmation value which will be validated
* @param {String} el The input field
*/
const emailConfirmation = function (value, el) {
    const formattedValue = value.toLowerCase();
    const isValid = formattedValue === $(el).closest('fieldset').find('[id$=email]').val().toLowerCase() ? true : false;
    return isValid;
};

/**
* @function
* @description Validates a given email address against the email regex
* @param {String} value The email address which will be validated
* @param {String} el The input field
*/
const validatePassword = function (value, el) { /* eslint-disable-line */
    const isValid = regex.password.test(value);
    return isValid;
};

/**
* @function
* @description Validates a password input
* @param {String} value The password value which will be validated
* @param {String} el The input field
*/
const passwordConfirmation = function (value, el) {
    const isValid = value === $(el).closest('fieldset').find('[id*=_password_]').val() ? true : false;
    return isValid;
};

/**
* @function
* @description Validates a given postal code against the regex
* @param {String} value The postal code which will be validated
* @param {String} el The input field
*/
const validatePostalCode = function (value, el) {
    const $el = $(el);

    if (!$el.hasClass('required') && value === '') {
        return true;
    }

    const postalCodeRegex = new RegExp($(el).attr('regex'));
    let formattedValue = $.trim(value.toUpperCase());

    $el.val(formattedValue);

    let isValid = (postalCodeRegex).test($.trim(formattedValue));

    if (!isValid && $el.data('requires-additional-formatting')){
        formattedValue = formHelper.formatUKPostalCodeSpace($el, formattedValue);
        isValid = (postalCodeRegex).test(formattedValue);
    }
    return isValid;
};

const validateCOCNumber = function (value, el) {
    if (!$(el).hasClass('required') && value === '') {
        return true;
    }
    const formattedValue = value.toUpperCase();
    $(el).val(formattedValue);
    return regex.cocNumber.test($.trim(formattedValue));
};

const validateVATNumber = function (value, el) {
    if (!$(el).hasClass('required') && value === '') {
        return true;
    }
    const formattedValue = value.toUpperCase();
    $(el).val(formattedValue);
    return regex.vat.test($.trim(formattedValue));
};

const validateRegexAttribute = function (value, el) {
    if (!$(el).hasClass('required') && value === '') {
        return true;
    }

    const regex = new RegExp($(el).attr('regex'));
    return regex.test($.trim(value));
};

/**
* @function
* @description Validates state based on a given postal code
* @param {String} value The state id which will be validated
* @param {String} el The input field
*/

const setIsValidG = function(value){
    isvalidG = value;
};

const validateStateFromPostal = function (value, el) {
    const $fieldset = $(el).closest('fieldset');
    const $postal = $fieldset.find('[id$=_postal]').val();
    const $country = $fieldset.find('[id$=_country]').val();
    google.places.compareStateToPostalCode($postal, $country,value, setIsValidG);
    return isvalidG;
};

const validateMaxLengthAllowed = function (value, el) {
    const $el = $(el);
    const maxLength = parseInt($el.attr('maxlengthallowed'),10);
    const valid = value.length <= maxLength;

    if (valid) {
        return valid;
    }

    $el.val(value.substr(0, maxLength + 1));
    return false;
};

const validatePersonalizedName = function (value, el) { /* eslint-disable-line */
    return !regex.emojis.test($.trim(value));
};

/**
 * @function
 * @description Validates a given date
 * @param {String} value The date which will be validated
 * @param {String} el The input field
 */
function validateBirthdayOther(value, el) {
    const isOptional = this.optional(el);
    let isValid;

    // if user inputs less than 6 characters, do not validate
    if (value.length < 6) {
        return isOptional;
    }

    const splitValue = getSplitValueDate(value);

    const formattedValue = splitValue.join('/');
    $(el).val(formattedValue);
    // get regex pattern for specific country or use 'other' as default
    const regexDatePatternCountry = regex.date[currentCountryCode.toLowerCase()] ? currentCountryCode.toLowerCase() : 'other';
    isValid = regex.date[regexDatePatternCountry].test($.trim(formattedValue));

    // check if the day is valid (not like 31st of Feb)
    if (isValid) {
        const day = currentCountryCode === 'US' ? splitValue[1] : splitValue[0];
        const month = currentCountryCode === 'US' ? splitValue[0] : splitValue[1];
        const year = splitValue[2];
        const currentYear = new Date().getFullYear();

        const date = new Date(year, parseInt(month) - 1, day);
        isValid = year < currentYear && (Boolean(+date) && date.getDate() === parseInt(day));
    }

    return isOptional || isValid;
}

function getSplitValueDate(value) {
    // add 0 if day or month are a single digit
    const splitValue = value.trim().split(/[.,\/ -]/);

    for (let i = 0; i < splitValue.length; i++) {
        if (i !== splitValue.length - 1 && splitValue[i].length === 1) {
            splitValue[i] = '0' + splitValue[i];
        }

        // if user inputs only 2 digits for the year (here we always consider that the last value)
        // add '19' or '20' in front
        if (i === splitValue.length - 1) {
            const currentYearInTwoDigits = new Date().getFullYear().toString().substr(-2);

            if (splitValue[i].length === 2) {
                splitValue[i] = splitValue[i] < currentYearInTwoDigits ? '20' + splitValue[i] : '19' + splitValue[i];
            }
        }
    }

    return splitValue;
}

function validateBirthdayUS(value, el) {
    const isOptional = this.optional(el);
    let isValid;

    // if user inputs less than 6 characters, do not validate
    if (value.length < 3) {
        return isOptional;
    }

    // add 0 if day or month are a single digit
    const splitValue = value.trim().split(/[.,\/ -]/);
    for (let i = 0; i < splitValue.length; i++) {
        if (i !== splitValue.length && splitValue[i].length === 1) {
            splitValue[i] = '0' + splitValue[i];
        }
    }

    const formattedValue = splitValue.join('/');
    $(el).val(formattedValue);
    isValid = regex.date['birthdayUS'].test($.trim(formattedValue));

    if (currentCountryCode !== 'US') {
        isValid = regex.date['other'].test($.trim(formattedValue + '/1900'));
    }

    // check if the day is valid (not like 31st of Feb)
    if (isValid) {
        let day = splitValue[1];
        let month = splitValue[0];
        const year = 1900;
        if (currentCountryCode !== 'US') {
            day = splitValue[0];
            month = splitValue[1];
        }

        const currentYear = new Date().getFullYear();
        const date = new Date(year, parseInt(month) - 1, day);

        isValid = year < currentYear && (Boolean(+date) && date.getDate() === parseInt(day));
    }

    return isOptional || isValid;
}

function validateDateAgainstNow(value, el) {
    let isValid = false;
    let isDate = false;

    const formattedValue = value.replace(/-| /g, '/');
    $(el).val(formattedValue);

    const dateString = $.trim(formattedValue);

    if (currentCountryCode === 'US'){
        isDate = regex.date.us.test(dateString);
    } else {
        isDate = regex.date.other.test(dateString);
    }

    if (isDate) {
        const parts = dateString.split('/');
        let d;
        if (currentCountryCode === 'US') {
            d = new Date(parts[2], parseInt(parts[0]) - 1, parts[1], 0, 0, 0, 0);
        } else {
            d = new Date(parts[2], parseInt(parts[1]) - 1, parts[0], 0, 0, 0, 0);
        }

        if (d.getTime() <= Date.now()) {
            isValid = true;
        }
    }

    return isValid;
}

function validateSocialSecurityNumber(ssn, el) {
    const isOptional = this.optional(el);
    const validate = $(el).data('validate');

    if (isOptional || !validate) {
        return true;
    }

    return regex.ssn.test(ssn);
}

function validateNifNumber(nifNumber, el) {
    const isOptional = this.optional(el);
    if (isOptional && nifNumber.length === 0) {
        return true;
    }

    return regex.nif.test(nifNumber);
}

function validateLoyaltySMSNewsletter(value, el) {
    if (value !== 'true') {
        return true;
    }

    const phone = $(el).closest('form').find('.smsphone');

    if (!phone.length) {
        return true;
    }

    return !!phone.val().trim().length;
}

function validateSMSPhone(value, el) { /* eslint-disable-line */
    const addToSmsListCheckbox = $('[id$=_addtosmslist]').length ? $('[id$=_addtosmslist]') : $('[id$=_addtoloyaltysmslist]');

    if (!addToSmsListCheckbox.is(':checked')) {
        return true;
    }

    return !!value.trim().length;
}

function validateRequiredAge(value, el) {
    if (currentCountryCode.toLowerCase() === 'us') {
        return true;
    }

    const $el = $(el);
    const minAgePreset = $el.data('min-age');
    const minAge = typeof minAgePreset !== 'undefined' ? minAgePreset : 16;

    const splitValue = getSplitValueDate(value);
    const birtday = new Date(splitValue[2] + '/' + splitValue[1] + '/' + splitValue[0]);
    const now = new Date();

    let diff = now.getFullYear() - birtday.getFullYear();

    if (now.getMonth() < birtday.getMonth()) {
        diff--;
    } else if (birtday.getMonth() === now.getMonth() && now.getDate() < birtday.getDate()) {
        diff--;
    }

    if (diff < minAge) {
        return false;
    }

    return true;
}

function validateRequiredAgeErrorMessage(value, el) {
    const $el = $(el);
    const minAgePreset = $el.data('min-age');
    const minAge = typeof minAgePreset !== 'undefined' ? minAgePreset : 16;
    const errorMessage = String.format(Resources.VALIDATE_BIRTHDAY_MIN_AGE, minAge);

    if (errorMessage) {
        return errorMessage;
    }
}

function validateOrderNumber(value, el) {
    const isOptional = this.optional(el);
    if (isOptional && value.length === 0) {
        return true;
    }

    const orderNumberRegex = new RegExp(Resources.ORDER_VALIDATION_REGEX);
    return orderNumberRegex.test($.trim(value));
}

/**
* Add password validation method to jQuery validation plugin.
* Text fields must have 'passwordcheck' and 'passwordconfirm' css class to be validated
* Note: All password fields must have 'passwordcheck' css class to be validated  (e.g. registration page)
*/
$.validator.methods.required = function(value, element) {
    return !!value && value !== null && (element.type === 'password' || value.trim() !== '');
};

$.validator.addMethod('ordernumber', validateOrderNumber, Resources.VALIDATE_ORDERNUMBER);

$.validator.addMethod('passwordcheck', validatePassword, Resources.VALIDATE_PASSWORD);
$.validator.addMethod('passwordconfirm', passwordConfirmation, Resources.VALIDATE_PASSWORDCONFIRM);

/**
* Add email validation method to jQuery validation plugin.
* Text fields must have 'email' and 'emailconfirm' css class to be validated
*/
$.validator.addMethod('email', validateEmail, Resources.VALIDATE_EMAIL);
$.validator.addMethod('emailconfirm', emailConfirmation, Resources.VALIDATE_EMAILCONFIRM);

/**
* Add First Name and Last Name validation method to jQuery validation plugin.
* Text fields must have 'firstName' and 'lastName' css class to be validated
*/
$.validator.addMethod('firstName', validateName, validateNameErrorMessage);
$.validator.addMethod('lastName', validateName, validateNameErrorMessage);

/**
* Add email validation method to jQuery validation plugin.
* Text fields must have 'email' and 'emailconfirm' css class to be validated
*/
$.validator.addMethod('postal', validatePostalCode, Resources.VALIDATE_POSTALCODE);

$.validator.addMethod('dangerouspostal', function(value, el) {return value && !$(el).hasClass('excludedpostalerror');}, Resources.VALIDATE_DANGEROUS_POSTALCODE);

$.validator.addMethod('cocNumber', validateCOCNumber, Resources.VALIDATE_COCNUMBER);

$.validator.addMethod('btwVatNumber', validateVATNumber, Resources.VALIDATE_VATNUMBER);

$.validator.addMethod('street', validateRegexAttribute, Resources.VALIDATE_STREET);

$.validator.addMethod('houseNumber', validateRegexAttribute, Resources.VALIDATE_HOUSENUMBER);

/**
 * Add state from postal code validation method to jQuery validation plugin.
 * Text fields must have 'state' css class to be validated based on postal code
 */
$.validator.addMethod('stateUS', validateStateFromPostal, Resources.VALIDATE_STATE_FROM_POSTAL);

/**
 * Add date validation method to jQuery validation plugin.
 * Text fields must have 'date' css class to be validated as date
 */
$.validator.addMethod('date-max-now', validateDateAgainstNow, Resources.VALIDATE_DATE_MAX_NOW);
$.validator.addMethod('date', validateBirthdayOther, Resources.VALIDATE_DATE);
$.validator.addMethod('birthday-us', validateBirthdayUS, Resources.VALIDATE_BIRTHDAY_USA);
$.validator.addMethod('min-age', validateRequiredAge, validateRequiredAgeErrorMessage);

/**
 * Add ssn validation method to jQueru validation plugin.
 */
$.validator.addMethod('ssn', validateSocialSecurityNumber, Resources.VALIDATE_SSN);

/**
 * Add NIF validation method to jQuery validation plugin.
 */
 $.validator.addMethod('nif', validateNifNumber, Resources.VALIDATE_NIF);

/**
* Add phone validation method to jQuery validation plugin.
* Text fields must have 'phone' css class to be validated as phone
*/
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
* Add CCOwner validation method to jQuery validation plugin.
* Text fields must have 'owner' css class to be validated as not a credit card
*/
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

$.validator.addMethod('emptyselect', emptySelect, Resources.VALIDATE_REQUIRED);

$.validator.addMethod('personalizedname', validatePersonalizedName, Resources.SPECIAL_CHARACTERS);

$.validator.addMethod('maxlengthallowed', validateMaxLengthAllowed, $.validator.format(Resources.VALIDATE_MAXLENGTH));

$.validator.addMethod('loyaltysmslist', validateLoyaltySMSNewsletter, Resources.VALIDATE_LOYALTYSMS);

$.validator.addMethod('smsphone', validateSMSPhone, Resources.VALIDATE_LOYALTYSMSPHONE);

/**
* Add gift cert amount validation method to jQuery validation plugin.
* Text fields must have 'gift-cert-amont' css class to be validated
*/
$.validator.addMethod('gift-cert-amount', function (value, el) {
    const isOptional = this.optional(el);
    const isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
* Add positive number validation method to jQuery validation plugin.
* Text fields must have 'positivenumber' css class to be validated as positivenumber
*/
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

$.extend($.validator.messages, {
    required: Resources.VALIDATE_REQUIRED,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
    minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN)
});

const validator = {
    regex: regex,
    settings: settings,
    init: function () {
        const self = this;
        $('form:not(.suppress):not(.js-pdp-add-to-cart-form)').each(function () {
            $(this).validate(self.settings);
        });
        $('form.js-pdp-add-to-cart-form').each(function () {
            const settings = $.extend(true, self.settings, {ignore:['hidden:not(select)']});
            $(this).validate(settings);
        });

        //Prevent posting form multiple times
        $(document).off('submit.postback','form.js-postback').on('submit.postback','form.js-postback', function (e) {
            const $this = $(this);
            if ($this.valid()) {
                const submit = $this.find('button[type=submit]');
                submit.addClass('btn--disabled');
                const spinner = $('.js-spinner-general', submit);

                if (spinner.length) {
                    submit.addClass('button-loading');
                    spinner.addClass('spinner-visible');
                }

                const recaptchaContainerId = $this.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR);
                // if there is recaptcha -> only submit once the recaptcha is validated (js-recaptchadone class will be added after validation)
                if ($('#' + recaptchaContainerId).length > 0 && $this.hasClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS) && !$this.hasClass(recaptchaConfig.CONSTANTS.CHALLENGE_DONE_CLASS)) {
                    recaptchaConfig.executeForContainer(recaptchaContainerId);
                    e.preventDefault();
                    return false; // form will be submitted in the handler functino registered in recaptcha for 'recaptchaContainerId' div
                }
                recaptchaConfig.removeChallengeDoneClass(recaptchaContainerId);

                $this.submit(function () {
                    return false;
                });
                return true;
            }
            return false;
        });
    },
    initForm: function (element) {
        $(element).validate(this.settings);
    },

    validatePostalCode: validatePostalCode,
    validatePersonalizedName: validatePersonalizedName
};

$.validator.messages.required = function ($1, ele) { /* eslint-disable-line */
    const requiredText = $(ele).attr('data-required-text');
    return requiredText || '';
};

module.exports = validator;
